// extracted by mini-css-extract-plugin
export var banner = "_fh-0";
export var closeButton = "_fh-2";
export var greenCheckmark = "_fh-3";
export var hereLink = "_fh-4";
export var titleIcon = "_fh-1";